const REACTION_TYPES = [
    "LIKE",
    "SUPPORT",
    "CELEBRATE",
    "APPRECIATE",
    "INTERESTED",
    "ACKNOWLEDGE",
] as const;

type ReactionType = (typeof REACTION_TYPES)[number];

const REACTION_EMOJIS = {
    LIKE: "👍",
    SUPPORT: "❤️",
    CELEBRATE: "🎉",
    APPRECIATE: "🙌",
    INTERESTED: "👀",
    ACKNOWLEDGE: "✅",
} as const satisfies Record<ReactionType, string>;

interface ReactionCount {
    type: ReactionType;
    count: number;
}

interface ReactionUser {
    id: number;
    firstName: string;
    lastName: string;
    picture: string | null;
}

interface AttributedReaction extends ReactionCount {
    users: readonly ReactionUser[];
}

function resolveReactionAction(
    current: ReactionType | null,
    clicked: ReactionType,
): "set" | "remove" {
    return current === clicked ? "remove" : "set";
}

function getReactionPreview(reactionCounts: readonly ReactionCount[], maxVisible = 2) {
    const sortedReactions = reactionCounts
        .filter(({ count }) => count > 0)
        .sort(
            (a, b) =>
                b.count - a.count ||
                REACTION_TYPES.indexOf(a.type) - REACTION_TYPES.indexOf(b.type),
        );
    const visibleCount = Math.max(0, Math.trunc(maxVisible));

    return {
        sortedReactions,
        visibleReactions: sortedReactions.slice(0, visibleCount),
        overflowCount: sortedReactions
            .slice(visibleCount)
            .reduce((total, { count }) => total + count, 0),
    };
}

export { REACTION_TYPES, REACTION_EMOJIS, resolveReactionAction, getReactionPreview };
export type { AttributedReaction, ReactionCount, ReactionType, ReactionUser };
